export default "__VITE_ASSET__B9IW1Lbp__"